import instance from "./api";
import EndPoints from "./api-endpoints";

const getPolicy = async (claimType: string | null, policyNumber: string) => {
  try {
    return instance
      .get(EndPoints.policy + "/" + claimType + "/" + policyNumber)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error.response;
      });
  } catch (error) {
    return error;
  }
};

const getCaseCreationPolicy = async (claimType: string | null, policyNumber: string) => {
  try {
    return instance
      .get(EndPoints.caseCreationPolicy + "/" + claimType + "/" + policyNumber)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error.response;
      });
  } catch (error) {
    return error;
  }
};

const getCaseCreationPolicyBySearch = async (
  claimType: string | null,
  searchType: "POLICY_NUMBER" | "ID_NUMBER",
  searchValue: string,
) => {
  try {
    return instance
      .get(EndPoints.caseCreationPolicy + "/search/" + claimType, {
        params: { searchType, searchValue },
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error.response;
      });
  } catch (error) {
    return error;
  }
};

const getOtp = async (phoneNumber: any) => {
  try {
    return instance
      .post(
        EndPoints.getOtp,
        { phoneNumber },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error.response;
      });
  } catch (error) {
    return error;
  }
};

const verifyOtp = async (phoneNumber: string, otp: string) => {
  try {
    return instance
      .post(
        EndPoints.verifyOtp,
        { phoneNumber, otp },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error.response;
      });
  } catch (error) {
    return error;
  }
};

const createClaim = async (formData: any) => {
  try {
    return instance
      .post(EndPoints.createClaim, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Accept: "*/*",
        },
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error.response;
      });
  } catch (error) {
    return error;
  }
};

const createClaimForTenPercent = async (formData: any) => {
  try {
    return instance
      .post(EndPoints.createClaimForTenPercent, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Accept: "*/*",
        },
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error.response;
      });
  } catch (error) {
    return error;
  }
};

const getClaimStatus = async (
  policyNumber: string | undefined,
  iceClaimNumber: string | undefined
) => {
  try {
    return instance
      .get(EndPoints.claimStatus, {
        params: {
          ...(policyNumber && { policyNumber }),
          ...(iceClaimNumber && { iceClaimNumber }),
        },
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error.response;
      });
  } catch (error) {
    return error;
  }
};

const getAllRelations = async () => {
  try {
    return instance
      .get(EndPoints.getAllRelations)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error.response;
      });
  } catch (error) {
    return error;
  }
};

const getAllCountries = async () => {
  try {
    return instance
      .get(EndPoints.getAllCountries)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error.response;
      });
  } catch (error) {
    return error;
  }
};

const getQuotableItems = async (kind?: string) => {
  try {
    return instance
      .get(EndPoints.getQuotableItems, {
        params: {
          activeOnly: true,
          ...(kind && { kind }),
        },
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error.response;
      });
  } catch (error) {
    return error;
  }
};

const getBenefitDetails = async (policyNumber: string, payload: any) => {
  try {
    return instance
      .post(EndPoints.benefitDetails, payload, {
        params: {
          policy_number: policyNumber,
        },
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error.response;
      });
  } catch (error) {
    return error;
  }
};

export {
  getPolicy,
  getCaseCreationPolicy,
  getCaseCreationPolicyBySearch,
  createClaim,
  createClaimForTenPercent,
  getClaimStatus,
  getAllRelations,
  getAllCountries,
  getBenefitDetails,
  getOtp,
  verifyOtp,
  getQuotableItems,
};
